import {
  AppBar,
  Box,
  Button,
  Dialog,
  IconButton,
  Slide,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import AppBarCustom from "../component/AppBar";
import styled from "@emotion/styled";
import TableCustom from "../component/tableCustom";
import {
  AddRounded,
  DeleteRounded,
  EditRounded,
} from "@mui/icons-material";
import Api from "../api/RestApi.json";
import { useNavigate } from "react-router-dom";
import React from "react";
import axios from "axios";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function PenggunaPage(params) {
  const theme = useTheme();
  const goTo = useNavigate();
  const [row, setRow] = React.useState(params.data);
  const [deleteStatus, setDeleteStatus] = React.useState(null);

  const deletePost = async (id) => {
    setDeleteStatus(null);
    try {
      var response = "";
      response = await axios.delete(Api.pengguna + "/" + id);
      if (response !== "") {
        setDeleteStatus("Data ID-" + id + " Berhasil dihapus");
        setRow(row.filter((item) => item.id !== id));
        goTo(0)
      }
    } catch (error) {
      console.error("Error delete file:", error);
      setDeleteStatus("File gagal dihapus. Tolong Muat Ulang Halaman.");
    }
  };

  const columns = [
    {
      field: "nomor",
      headerName: "No",
      flex: 1,
      minWidth: 30,
    },
    {
      field: "name",
      headerName: "Nama",
      flex: 3,
      minWidth: 150,
    },
    {
      field: "username",
      headerName: "Username",
      flex: 3,
      minWidth: 100,
    },

    {
      field: "actions",
      headerName: "Actions",
      flex: 2,
      minWidth: 150,
      align: "center",
      renderCell: (params) => {
        return (
          // <Button onClick={(e) => console.log(params.row)} variant="contained">
          //   Show
          // </Button>
          <Stack direction={"row"} spacing={1}>
            <Tooltip title="Edit Data">
              <IconButton
                onClick={(e) =>
                  goTo("/pengguna-form", { state: { data: params.row } })
                }
              >
                <EditRounded color="warning" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Hapus Data">
              <IconButton
                onClick={(e) => {
                  deletePost(params.row.id);
                }}
              >
                <DeleteRounded color="error" />
              </IconButton>
            </Tooltip>
          </Stack>
        );
      },
    },
  ];
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        padding: 0,
        bgcolor: "#E1E1E1",
      }}
    >
      <AppBarCustom selected="Pengguna" />
      {/* <Toolbar sx={{ padding: 10 }} /> */}

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader theme={theme} />
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", marginBottom: 2 }}
          align="left"
        >
          Data Pengguna
        </Typography>

        <Box padding={2} bgcolor={"white"} borderRadius={4}>
          <Box flexGrow={1} justifyContent={"right"} justifySelf={"right"}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddRounded />}
              onClick={(e) => goTo("/pengguna-form", { state: { data: {} } })}
            >
              Tambah Data
            </Button>
          </Box>

          {deleteStatus && (
            <Typography
              variant="body2"
              color="error.main"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <DeleteRounded sx={{ ml: 1 }} /> {deleteStatus}
            </Typography>
          )}
          <TableCustom
            column={columns}
            row={row.map((item, index) => ({
              nomor: index + 1,
              ...item,
            }))}
          />
        </Box>
      </Box>
    </Box>
  );
}